import { helper } from '@ember/component/helper';

export default helper(function joinHelper([ texts, delimiter = ', ' ]) {
  if (!texts) {
    return '';
  }
  texts = [].concat(texts);
  if (!texts.length) {
    return '';
  }
  return texts
    // Using reduce, because EmberArrays don't have join
    .reduce((text, value, i) =>
      text + (i ? delimiter : '') + (value || ''),
    '');
});
